type AdminSellerCreateSuccessParams = {
  locale: string;
  sellerId?: string;
  successMessage: string;
  toast: {
    success: (message: string) => void;
  };
  router: {
    replace: (href: string) => void;
  };
};

export function handleAdminSellerCreateSuccess({
  locale,
  sellerId,
  successMessage,
  toast,
  router,
}: AdminSellerCreateSuccessParams) {
  toast.success(successMessage);

  if (!sellerId) {
    return false;
  }

  router.replace(`/${locale}/admin/sellers/${sellerId}`);
  return true;
}
